import React from 'react';
import '../../styles.css';

export default function Button(props) {
    return (
        <>
            <button className={`${props.classes} tw:px-5 tw:py-3 tw:text-sm tw:font-medium tw:text-center tw:text-white tw:bg-blue-700 tw:rounded-lg tw:cursor-pointer tw:hover:bg-blue-800 tw:focus:ring-4 tw:focus:ring-blue-300 tw:dark:bg-blue-600 tw:dark:hover:bg-blue-700 tw:dark:focus:ring-blue-800`}>
                {props.children}
            </button>
        </>
    )
};